import { render, staticRenderFns } from "./CreditRisk.vue?vue&type=template&id=a4af065e&"
import script from "./CreditRisk.vue?vue&type=script&lang=js&"
export * from "./CreditRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports